import { render, staticRenderFns } from "./SpaceExternalStorage.vue?vue&type=template&id=44f57c56&scoped=true&"
import script from "./SpaceExternalStorage.vue?vue&type=script&lang=js&"
export * from "./SpaceExternalStorage.vue?vue&type=script&lang=js&"
import style0 from "./SpaceExternalStorage.vue?vue&type=style&index=0&id=44f57c56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f57c56",
  null
  
)

export default component.exports